/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateWorkflowDocumenttypeDto } from '../models/work-create-workflow-documenttype-dto';
import { WorkCreateWorkflowProjectDto } from '../models/work-create-workflow-project-dto';
import { WorkCreateWorkflowStandardtaskDto } from '../models/work-create-workflow-standardtask-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkUpdateWorkflowDocumenttypeDto } from '../models/work-update-workflow-documenttype-dto';
import { WorkUpdateWorkflowProjectDto } from '../models/work-update-workflow-project-dto';
import { WorkUpdateWorkflowStandardtaskDto } from '../models/work-update-workflow-standardtask-dto';
import { WorkWorkflow } from '../models/work-workflow';

@Injectable({ providedIn: 'root' })
export class WorkWorkflowsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `workflowsV2ControllerFindAllPaginated()` */
  static readonly WorkflowsV2ControllerFindAllPaginatedPath = '/v2/workflows';

  /**
   * Required permissions: workflows:read, workflows:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workflowsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  workflowsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.containertypeId=$not:$like:John Doe&filter.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.containertypeId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>containertypeId</li>
     * <li>name</li>
     * <li>standardtask.name</li>
     * <li>action</li>
     * <li>documenttype.name</li>
     * <li>active</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'containertypeId:ASC' | 'containertypeId:DESC' | 'name:ASC' | 'name:DESC' | 'standardtask.name:ASC' | 'standardtask.name:DESC' | 'action:ASC' | 'action:DESC' | 'documenttype.name:ASC' | 'documenttype.name:DESC' | 'active:ASC' | 'active:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,standardtask.name,documenttype.name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>standardtask.name</li>
     * <li>documenttype.name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkWorkflow>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'containertypeId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWorkflowsV2Service.WorkflowsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.containertypeId', params['filter.containertypeId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkWorkflow>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'containertypeId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: workflows:read, workflows:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workflowsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  workflowsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.containertypeId=$not:$like:John Doe&filter.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.containertypeId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>containertypeId</li>
     * <li>name</li>
     * <li>standardtask.name</li>
     * <li>action</li>
     * <li>documenttype.name</li>
     * <li>active</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'containertypeId:ASC' | 'containertypeId:DESC' | 'name:ASC' | 'name:DESC' | 'standardtask.name:ASC' | 'standardtask.name:DESC' | 'action:ASC' | 'action:DESC' | 'documenttype.name:ASC' | 'documenttype.name:DESC' | 'active:ASC' | 'active:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,standardtask.name,documenttype.name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>standardtask.name</li>
     * <li>documenttype.name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkWorkflow>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'containertypeId'?: (string | Array<string>);
};
};
}> {
    return this.workflowsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkWorkflow>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'containertypeId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkWorkflow>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'containertypeId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `workflowsV2ControllerCreate()` */
  static readonly WorkflowsV2ControllerCreatePath = '/v2/workflows';

  /**
   * Required permissions: workflows:create, workflows:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workflowsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workflowsV2ControllerCreate$Response(
    params: {
      body: (WorkCreateWorkflowDocumenttypeDto | WorkCreateWorkflowStandardtaskDto | WorkCreateWorkflowProjectDto)
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkWorkflow>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWorkflowsV2Service.WorkflowsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkWorkflow>;
      })
    );
  }

  /**
   * Required permissions: workflows:create, workflows:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workflowsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workflowsV2ControllerCreate(
    params: {
      body: (WorkCreateWorkflowDocumenttypeDto | WorkCreateWorkflowStandardtaskDto | WorkCreateWorkflowProjectDto)
    },
    context?: HttpContext
  ): Observable<WorkWorkflow> {
    return this.workflowsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkWorkflow>): WorkWorkflow => r.body)
    );
  }

  /** Path part for operation `workflowsV2ControllerFindOneById()` */
  static readonly WorkflowsV2ControllerFindOneByIdPath = '/v2/workflows/{id}';

  /**
   * Required permissions: workflows:read, workflows:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workflowsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  workflowsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkWorkflow>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWorkflowsV2Service.WorkflowsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkWorkflow>;
      })
    );
  }

  /**
   * Required permissions: workflows:read, workflows:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workflowsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  workflowsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkWorkflow> {
    return this.workflowsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkWorkflow>): WorkWorkflow => r.body)
    );
  }

  /** Path part for operation `workflowsV2ControllerUpdate()` */
  static readonly WorkflowsV2ControllerUpdatePath = '/v2/workflows/{id}';

  /**
   * Required permissions: workflows:update, workflows:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workflowsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workflowsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: (WorkUpdateWorkflowDocumenttypeDto | WorkUpdateWorkflowStandardtaskDto | WorkUpdateWorkflowProjectDto)
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkWorkflow>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWorkflowsV2Service.WorkflowsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkWorkflow>;
      })
    );
  }

  /**
   * Required permissions: workflows:update, workflows:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workflowsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workflowsV2ControllerUpdate(
    params: {
      id: number;
      body: (WorkUpdateWorkflowDocumenttypeDto | WorkUpdateWorkflowStandardtaskDto | WorkUpdateWorkflowProjectDto)
    },
    context?: HttpContext
  ): Observable<WorkWorkflow> {
    return this.workflowsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkWorkflow>): WorkWorkflow => r.body)
    );
  }

}
